module.exports = __webpack_public_path__ + "img/item7.c7d0f757.png";